import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../components/AppIcon';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 bg-background/95 backdrop-blur border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center gap-3">
          <Link to="/" className="flex items-center gap-2 text-foreground hover:text-primary transition-colors">
            <Icon name="ArrowLeft" size={20} />
            <Icon name="Send" size={24} className="text-primary" />
            <span className="font-bold text-lg">POSTRequest</span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-foreground mb-2">Privacy Policy</h1>
        <p className="text-muted-foreground mb-8">Last updated: March 27, 2026</p>

        <div className="prose prose-neutral dark:prose-invert max-w-none space-y-6">
          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">1. Information We Collect</h2>
            <p className="text-muted-foreground leading-relaxed">
              When you use POSTRequest, we collect information you provide directly: your name, email address, and profile picture through Google Sign-In. When you connect social media accounts (LinkedIn, X), we store OAuth access tokens securely to publish content on your behalf.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">2. How We Use Your Information</h2>
            <p className="text-muted-foreground leading-relaxed">
              We use your information to: authenticate your account, generate AI-powered content based on your ideas, publish content to your connected social media accounts, and track your usage for subscription management. We do not sell your personal data to third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">3. AI Content Generation</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your ideas and code snippets are sent to AI services (OpenAI) to generate platform-optimized content. We do not use your content to train AI models. Generated content is stored in your account for your reference.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">4. Social Media Tokens</h2>
            <p className="text-muted-foreground leading-relaxed">
              OAuth tokens for LinkedIn and X are stored securely and encrypted. We request only the minimum permissions needed to publish content. You can disconnect your accounts at any time, which immediately revokes our access and deletes stored tokens.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">5. Data Storage & Security</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your data is stored on Supabase (hosted on AWS) with row-level security policies ensuring you can only access your own data. All data is transmitted over HTTPS. We do not store passwords — authentication is handled through Google OAuth or Supabase Auth.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">6. Payment Information</h2>
            <p className="text-muted-foreground leading-relaxed">
              Payment processing is handled by Razorpay. We do not store your credit card or banking details. Razorpay processes and stores payment information securely according to PCI-DSS standards.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">7. Data Deletion</h2>
            <p className="text-muted-foreground leading-relaxed">
              You can delete your account and all associated data by contacting us at support@postrequest.social. Upon deletion, all your content, tokens, and personal information are permanently removed from our systems.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">8. Cookies</h2>
            <p className="text-muted-foreground leading-relaxed">
              We use essential cookies for authentication and session management only. We do not use tracking cookies or share cookie data with third parties.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-foreground mt-8 mb-3">9. Contact</h2>
            <p className="text-muted-foreground leading-relaxed">
              For privacy-related questions or data requests, contact us at support@postrequest.social.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default Privacy;
